import { writable } from "svelte/store"
import { DataHandlerUser, User } from "luxedo-data"

let user: User
export const UserStore = writable(null)

DataHandlerUser.addListener((changedIDs) => {
	if (changedIDs.length > 0) {
		UserStore.set(DataHandlerUser.get(changedIDs[0]))
	}
})

UserStore.subscribe((v) => (user = v))

/**
 * ONLY to be called in places where the UserStore may not yet be defined (e.g., inside a DataHandler)
 */
export function getCurrentUser() {
	return user
}
